//For fast bundle code

document.addEventListener("DOMContentLoaded", function() {
  function openAllAccordions() {
    const allPanels = document.querySelectorAll('[class^="Accordion_panel"]');
    const allHeads = document.querySelectorAll('[class^="Accordion_head"]');
    const allArrows = document.querySelectorAll('[class^="Accordion_arrow"]');

    if (allPanels.length > 0) {
      allPanels.forEach(panel => {
        panel.classList.add("rb_active");
        panel.style.display = "block";
        panel.style.maxHeight = "unset";
      });

      allHeads.forEach(head => {
        head.classList.add("rb_active");
      });

      allArrows.forEach(arrow => {
        arrow.classList.add("rb_active");
      });
      return true;
    }
    return false;
  }
  if (!openAllAccordions()) {
    const observer = new MutationObserver(() => {
      if (openAllAccordions()) {
        observer.disconnect(); 
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
});



(function () {
  'use strict';

  function hydrateVideo(video) {
    if (!video) return;

    // force copy all <source data-src> to src
    video.querySelectorAll('source[data-src]').forEach(source => {
      const newSrc = source.dataset.src;
      if (newSrc && source.getAttribute('src') !== newSrc) {
        source.setAttribute('src', newSrc);
      }
    });

    // reload the video after swapping sources
    try { video.load(); } catch (e) {}

    // autoplay if flagged
    if (
      video.hasAttribute('autoplay') ||
      video.hasAttribute('data-video-autoplay') ||
      video.dataset.videoAutoplay === 'true'
    ) {
      video.muted = true;
      video.playsInline = true;
      const p = video.play();
      if (p && typeof p.catch === 'function') p.catch(() => {});
    }

    // mark as hydrated for later, but don’t skip if already had data-hydrated
    video.dataset.hydrated = '1';
  }

  function primeExisting() {
    document.querySelectorAll('video[data-video-type="native"]').forEach(hydrateVideo);
  }

  // mutation observer to hydrate new videos added later
  const observer = new MutationObserver(mutations => {
    mutations.forEach(m => {
      if (m.addedNodes && m.addedNodes.length) {
        m.addedNodes.forEach(node => {
          if (!(node instanceof HTMLElement)) return;
          if (node.matches && node.matches('video[data-video-type="native"]')) {
            hydrateVideo(node);
          } else if (node.querySelectorAll) {
            node.querySelectorAll('video[data-video-type="native"]').forEach(hydrateVideo);
          }
        });
      }
    });
  });

  function startAll() {
    primeExisting();
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  // trigger once on first mouse move or touch
  window.addEventListener('mousemove', startAll, { once: true, passive: true });
  window.addEventListener('touchstart', startAll, { once: true, passive: true });
})();






document.addEventListener("DOMContentLoaded", function () {

  const swatches = document.querySelectorAll("label.variant-swatch");
  const mediaItems = document.querySelectorAll(".itg_ctm_variant_img");
  const targetWrapper = document.querySelector(".itg_product_img_update");

  if (!targetWrapper) return;

  swatches.forEach((swatch) => {
    swatch.addEventListener("click", function () {

      const selectedVariant = this.getAttribute("data-color");
      if (!selectedVariant) return;

      mediaItems.forEach((media) => {
        const mediaVariant = media.getAttribute("data-variant-name");

        if (
          mediaVariant &&
          mediaVariant.toLowerCase() === selectedVariant.toLowerCase()
        ) {
          targetWrapper.innerHTML = media.innerHTML;
        }
      });

    });
  });

});

document.addEventListener("DOMContentLoaded", function () {

  const swatches = document.querySelectorAll("label.variant-swatch");
  const mediaItems = document.querySelectorAll(".itg_ctm_tumbvariant_img");
  const targetWrapper = document.querySelector(".itg_tumb_img_update");

  if (!targetWrapper) return;

  swatches.forEach((swatch) => {
    swatch.addEventListener("click", function () {

      const selectedVariant = this.getAttribute("data-color");
      if (!selectedVariant) return;

      mediaItems.forEach((media) => {
        const mediaVariant = media.getAttribute("data-variant-name");

        if (
          mediaVariant &&
          mediaVariant.toLowerCase() === selectedVariant.toLowerCase()
        ) {
          targetWrapper.innerHTML = media.innerHTML;
        }
      });

    });
  });

});

